import { render } from "./AddMap.vue?vue&type=template&id=22220f96&scoped=true"
import script from "./AddMap.vue?vue&type=script&lang=js"
export * from "./AddMap.vue?vue&type=script&lang=js"

import "./AddMap.vue?vue&type=style&index=0&id=22220f96&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22220f96"]])

export default __exports__